import { apiSlice } from "./ApiSlice";

const InvoiceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addInvoice: builder.mutation({
      query: (formData) => ({
        url: "/api/ClinicProfile/AddInvoice",
        method: "POST",
        body: formData,
      }),
    }),

    getInvoice: builder.query({
      query: (userClinicID) => ({
        url: `api/ClinicProfile/GetPatientInvoiceDropdown?userClinicID=${userClinicID}`,
        method: "GET",
      }),
    }),

    getTestItems: builder.query({
      query: (appointmentId) => ({
        url: `/api/ClinicProfile/GetInvoiceItem-TestsListDropdown?appointmentId=${appointmentId}`,
        method: "GET",
      }),
    }),

    getInvoiceView: builder.query({
      query: ({ invoiceNumber, appointmentId }) => ({
        url: `/api/ClinicProfile/GetPatientInvoiceView?invoiceNumber=${invoiceNumber}&appointmentId=${appointmentId}`,
        method: "GET",
      }),
    }),

    Getinvoicelist: builder.query({
      query: (clinicUserId) => {
        
        return {
          url: `/api/ClinicProfile/GetPatientsInvoiceListView?userClinicID=${clinicUserId}`,
          method: "GET"
        };
      },
    }),

    Getbillingoverview: builder.query({
      query: (patientUserUniqueID) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Billing-History?patientUserUniqueID=${patientUserUniqueID}`,
          method: "GET"
        };
      },
    }),

    Getbillingedit: builder.query({
      query: ({appointmentID,patientUserUniqueID,userClinicId}) => {
        return {
          url: `/api/ClinicProfile/GetPatientInvoice-Edit?appointmentID=${appointmentID}&patientUserUniqueID=${patientUserUniqueID}&userClinicID=${userClinicId}`,
          method: "GET"
        };
      },
    }),

  }),
});

export const {
  useAddInvoiceMutation,
  useLazyGetInvoiceQuery,
  useLazyGetTestItemsQuery,
  useLazyGetInvoiceViewQuery,
  useLazyGetinvoicelistQuery,
  useLazyGetbillingoverviewQuery,
  useLazyGetbillingeditQuery 
} = InvoiceApiSlice;
